import { Button, Stack } from '@mui/material';
import { useState } from 'react';
import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { KeyboardArrowUp } from '@mui/icons-material';

export type TenantActionMenuItem = {
  label: string;
  handleClick: () => void;
  isVisible?: boolean;
  disabled?: boolean;
};

interface TenantActionsMenuProps {
  menuItems: TenantActionMenuItem[];
}

const TenantActionsMenu = (props: TenantActionsMenuProps) => {
  const { menuItems } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack>
      <Button
        variant="contained"
        onClick={handleClick}
        endIcon={anchorEl ? <KeyboardArrowUp /> : <KeyboardArrowDownIcon />}
      >
        Actions
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {menuItems
          ?.filter((item) => item?.isVisible ?? true)
          ?.map((menuItem) => (
            <MenuItem
              key={menuItem?.label}
              onClick={() => {
                menuItem?.handleClick();
                handleClose();
              }}
              disabled={menuItem?.disabled}
            >
              {menuItem?.label}
            </MenuItem>
          ))}
      </Menu>
    </Stack>
  );
};

export default TenantActionsMenu;
